import { AxiosResponse } from "axios";
import { PlatformSalary } from "../../Model/Dto/Platform/PlatformSalary";
import { axiosWSPInstance } from "../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.PlatformSalary";

export const PlatformSalaryService = {
    getPersonSalarySummary: (personId: string): Promise<AxiosResponse<PlatformSalary.PlatformSalarySummaryDto[]>> =>
        axiosWSPInstance.get(`${ApiUrls.PlatformSalarySummary}/${personId}`),
    getPersonSalariesForYear: (personId: string, year: number): Promise<AxiosResponse<PlatformSalary.PlatformSalaryDataDto[]>>=>
        axiosWSPInstance.get(`${ApiUrls.PlatformSalary}`, { params: {
            personId: personId,
            year: year
        }}),
    createSalaryForYear: (request: PlatformSalary.PlatformSalaryDto): Promise<AxiosResponse> =>
        axiosWSPInstance.post(ApiUrls.PlatformSalary, request),
    updateSalaryForYear: (request: PlatformSalary.PlatformSalaryDto): Promise<AxiosResponse> =>
        axiosWSPInstance.put(ApiUrls.PlatformSalary, request),
    deleteSalaryByYear: (platformPeopleId: string, year: number): Promise<AxiosResponse> =>
        axiosWSPInstance.delete(`${ApiUrls.PlatformSalary}`, {params: {personId: platformPeopleId, year: year}})
}